import { IoSearch } from "react-icons/io5";

export default function AdminSearch({
  handleSearchSubmit,
  searchQuery,
  handleSearchInputChange,
  setShowResults,
  resultRef,
}) {
  return (
    <div className="d-flex justify-content-end my-2 me-2">
      <form className="d-flex align-items-center" onSubmit={handleSearchSubmit}>
        <div className="input-group">
          <button
            className="btn btn-warning"
            onClick={() => setShowResults((prev) => !prev)}
            ref={resultRef}
            type="submit"
          >
            جستجو
          </button>
          <input
            type="search"
            className="form-control border-end-0"
            placeholder="جستجو..."
            value={searchQuery}
            onChange={handleSearchInputChange}
            required
            dir="rtl"
          />
          <span className="input-group-text bg-white border-start-0">
            <IoSearch style={{ width: "1.75rem", height: "1.75rem" }} />
          </span>
        </div>
      </form>
    </div>
  );
}
